<div class="grow grid grid-cols-1 md:grid-cols-2 gap-4 bg-valamargray border-2 p-4 h-full">
    <div
        class="relative flex flex-col gap-4"
        [ngClass]="{'blur-[2px] pointer-events-none [&_*]:select-none': positionScoresLoading$ | async}">
        @if (positionScoresLoading$ | async) {
            <div class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50">
                <mat-spinner [diameter]="32"></mat-spinner>
            </div>
        }

        <h2 class="text-lg font-semibold">Radna mjesta s bodovima</h2>

        <input class="w-full md:w-[24rem] h-10 border focus:outline-none rounded-md p-2" type="text"
            placeholder="Pretraži s bodovima…" (input)="filterPositions($event)" />

        <div class="flex-1 border border-black/20 p-4 rounded-md">
            <cdk-virtual-scroll-viewport itemSize="50" class="h-full">
                <div *cdkVirtualFor="let positionScore of shownPositionScores"
                    class="flex justify-start items-center gap-4">
                    <h3 class="min-w-0 flex-1 truncate">{{ positionScore.name }}</h3>

                    <mat-button-toggle-group class="my-2" hideSingleSelectionIndicator
                        [(ngModel)]="positionScore.score">
                        @for (variant of positionScoresVariants; track variant.score) {
                            <mat-button-toggle [value]="variant.score">{{ variant.label }}</mat-button-toggle>
                        }
                    </mat-button-toggle-group>

                    <button class="valben-button" (click)="changePositionScore(positionScore)">
                        Promijeni
                    </button>
                </div>
            </cdk-virtual-scroll-viewport>
        </div>
    </div>

    <div
        class="relative flex flex-col gap-4"
        [ngClass]="{'blur-[2px] pointer-events-none [&_*]:select-none': unassignedPositionsLoading$ | async}">
        @if (unassignedPositionsLoading$ | async) {
            <div class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50">
                <mat-spinner [diameter]="32"></mat-spinner>
            </div>
        }

        <h2 class="text-lg font-semibold">Radna mjesta bez bodova</h2>

        <input class="w-full md:w-[24rem] h-10 border focus:outline-none rounded-md p-2" type="text"
            placeholder="Pretraži bez bodova…" (input)="filterUnassignedPositions($event)" />

        <div class="flex-1 border border-black/20 p-4 rounded-md">
            <cdk-virtual-scroll-viewport itemSize="50" class="h-full">
                <div *cdkVirtualFor="let unassignedPosition of shownUnassignedPositions"
                    class="flex justify-start items-center gap-4">
                    <h3 class="min-w-0 flex-1 truncate">{{ unassignedPosition.name }}</h3>

                    <mat-button-toggle-group class="my-2" hideSingleSelectionIndicator
                        [value]="unassignedPosition.score">
                        @for (variant of positionScoresVariants; track variant.score) {
                            <mat-button-toggle
                                [value]="variant.score"
                                (click)="toggleScore(unassignedPosition, variant.score)">
                                {{ variant.label }}
                            </mat-button-toggle>
                        }
                    </mat-button-toggle-group>

                    <button class="valben-button" (click)="assignPositionScore(unassignedPosition)">
                        Dodaj
                    </button>
                </div>
            </cdk-virtual-scroll-viewport>
        </div>
    </div>
</div>
